import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import InputGroup from "react-bootstrap/InputGroup";
import {connect} from "react-redux";
import React, {useEffect, useRef, useState} from "react";
import LoaderService from "../../../RetroAssets.System/LoaderService";
import {alert, confirm} from "devextreme/ui/dialog";
import apiClient from "../../../services/axios";
import {useNavigate} from "react-router-dom";
import cl from "../../../RetroAssets.System/Utilities";
import {Template, TextBox} from "devextreme-react";
import store from 'store'
import {onExcelExporting} from "../../../RetroAssets.System/CellRenderImage";
import {DataGrid} from "devextreme-react/data-grid";
import {ContextMenuTemplate, MoreOptionsButton} from "../../../RetroAssets.System/MoreOptionsButton";
import PropertyShortTermRentalDetails from "../../Popups/PropertyShortTermRentalDetails";

const mapStateToProps = ({settings}) => ({
    dispatch: settings.dispatch,
});

const PropertyShortTermRental = (props) => {
    const navigate = useNavigate();
    let shortTermRentalSpanString = "Property_ShortTermRentals";
    const [selectedProperty, setSelectedProperty] = useState([]);
    const pageSettings = JSON.parse(store.get("SettingsForShortTermRentals"))

    const gridInstance = useRef(null);
    const contractsSearchRef = useRef(null);
    const [gridData, setGridData] = useState([]);
    const [gridColumns, setGridColumns] = useState([]);
    const [gridCustomization, setGridCustomization] = useState({});

    const [shortTermRentalSettings, setShortTermRentalSettings] = useState({
        show: false,
        externalId: "",
        readOnly: false,
        property: ""
    })

    useEffect(() => {
        if (!pageSettings) {
            navigate(-1);
            return;
        }
        getData(false);
    }, []);

    function getData(showToast) {
        LoaderService.setData(true);
        let params = new URLSearchParams({
            externalId: pageSettings["externalId"], //"357458b0-e848-45f0-b83b-739aba9fbd3a"
        });
        apiClient
            .get("/Property/GetPropertyShortTermRentals?" + params)
            .then((response) => {
                try {
                    let data = JSON.parse(response.data);
                    setGridData(data[0]["Data"]);
                    let settings = data[1]["Settings"];
                    if (showToast) {
                        cl.showSuccessToast();
                    } else {
                        setGridColumns(settings[0][shortTermRentalSpanString][0]["Columns"]);
                        setGridCustomization(settings[0][shortTermRentalSpanString][3]["GridCustomization"][0]);
                    }
                    setSelectedProperty(pageSettings);
                    LoaderService.setData(false);
                } catch (e) {
                    LoaderService.setData(false);
                    return alert(response.data, "Error!");
                }
            })
            .catch((err) => {
                LoaderService.setData(false);
                console.log(err);
                return alert(err, "Error!");
            });
    }

    const generateContractStatus = (e, capitalText = false) => {
        if (!e) return;
        if (!e["Active"]) {
            //TERMINATED
            return (
                <label
                    key={e.key}
                    className={
                        capitalText
                            ? "text-capitalize form-check-label fs-4 fw-bold "
                            : "form-check-label"
                    }
                    htmlFor="ps-na"
                >
                    <span className="status-color"></span>
                    {e["ContractStatus"]}
                </label>
            );
        } else if (e["Terminated"] && e["Active"]) {
            //PENDING TERMINATION DETAILS
            return (
                <label
                    key={e.key}
                    className={
                        capitalText
                            ? "text-capitalize form-check-label fs-4 fw-bold "
                            : "form-check-label"
                    }
                    htmlFor="ps-unoccupied"
                >
                    <span className="status-color na"></span>
                    {e["ContractStatus"]}
                </label>
            );
        } else if (e["Overdue"]) {
            //OVERDUE
            return (
                <label
                    key={e.key}
                    className={
                        capitalText
                            ? "text-capitalize form-check-label fs-4 fw-bold "
                            : "form-check-label"
                    }
                    htmlFor="ps-overdue"
                >
                    <span className="status-color overdue"></span>
                    {e["ContractStatus"]}
                </label>
            );
        } else if (e["Due"]) {
            ///DUE
            return (
                <label
                    key={e.key}
                    className={
                        capitalText
                            ? "text-capitalize form-check-label fs-4 fw-bold "
                            : "form-check-label"
                    }
                    htmlFor="ps-occupied"
                >
                    <span className="status-color na"></span>
                    {e["ContractStatus"]}
                </label>
            );
        } else {
            return (
                <label
                    key={e.key}
                    className={
                        capitalText
                            ? "text-capitalize form-check-label fs-4 fw-bold "
                            : "form-check-label"
                    }
                    htmlFor="ps-occupied"
                >
                    <span className="status-color occupied"></span>
                    {e["ContractStatus"]}
                </label>
            );
        }
    };

    const generatePropertyStatus = (e) => {
        if (e["PurchasePaymentPlan"]) {
            //Payment Plan
            return (
                <label
                    key={props.key}
                    className="text-capitalize form-check-label fs-4 fw-bold"
                    htmlFor="ps-na"
                >
                    <span className="status-color na"></span>
                    {e["Status"]}
                </label>
            );
        } else if (!e["Available"]) {
            //Not Available
            return (
                <label
                    key={props.key}
                    className="text-capitalize form-check-label fs-4 fw-bold"
                    htmlFor="ps-unoccupied"
                >
                    <span className="status-color unoccupied"></span>
                    {e["Status"]}
                </label>
            );
        } else if (!e["Occupied"]) {
            //Unoccupied
            return (
                <label
                    key={props.key}
                    className="text-capitalize form-check-label fs-4 fw-bold"
                    htmlFor="ps-overdue"
                >
                    <span className="status-color overdue"></span>
                    {e["Status"]}
                </label>
            );
        } else if (e["Occupied"]) {
            //Occupied
            return (
                <label
                    key={props.key}
                    className="text-capitalize form-check-label fs-4 fw-bold"
                    htmlFor="ps-occupied"
                >
                    <span className="status-color occupied"></span>
                    {e["Status"]}
                </label>
            );
        }
    };

    const backToPreviousPage = () => {
        navigate(-1);
    }

    function markShortTermRentalAsSettled(id) {

        apiClient
            .get('/Property/MarkShortTermRentalAsSettled?' + new URLSearchParams({externalId: id}))
            .then(response => {
                try {
                    LoaderService.setData(false)
                    let resp = JSON.parse(response.data)
                    if (resp[0].response) {
                        getData(true)
                    } else {
                        return alert(resp[0].message, 'Warning!')
                    }
                } catch (e) {
                    LoaderService.setData(false)
                    return alert(response.data, 'Error!')
                }
            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })
    }

    //#region Data Grid Functions

    const clearFilter = () => {
        gridInstance.current?.instance().clearFilter();
        gridInstance.current?.instance().searchByText("");
        contractsSearchRef.current?.instance().option("value", null);
    };

    const searchShortTermRentalByText = (e) => {
        if (!e.event) return;
        gridInstance.current?.instance().searchByText(e.value ? e.value : null);
    };

    const addNewShortTermRental = () => {
        if (!pageSettings["Available"])
            return alert(
                "Current property is not available for short term rental.",
                "Warning!"
            );

        setShortTermRentalSettings({
            ...shortTermRentalSettings,
            externalId: "",
            property: pageSettings["externalId"],
            show: true,
            readOnly: false,
        })
    }

    const exportGridData = () => {
        onExcelExporting(gridInstance.current.instance())
    }

    const cellPrepared = e => {
        cl.setObjectColor(e)
        cl.setHeaderTooltip(e)
    }

    const contextMenu = e => {
        if (!e.row) return;
        if (e.row.rowType !== "data") return;
        e.items = [];
        e.component.selectRows(e.row.key);

        //View Details
        e.items.push({
            text: "View Details",
            icon: "eye",
            template: "contextMenuTemplate",
            onClick: function () {
                setShortTermRentalSettings({
                    ...shortTermRentalSettings,
                    externalId: e.row.key,
                    property: pageSettings["externalId"],
                    show: true,
                    readOnly: true,
                })
            },
        });

        //Edit Details
        e.items.push({
            text: "Edit Details",
            icon: "edit",
            template: "contextMenuTemplate",
            onClick: function () {
                if (e.row.data["Settled"])
                    return alert("Cannot edit rental details once it is marked as settled.", "Warning!")

                setShortTermRentalSettings({
                    ...shortTermRentalSettings,
                    externalId: e.row.key,
                    property: pageSettings["externalId"],
                    show: true,
                    readOnly: false,
                })
            },
        });

        //Mark As Settled
        e.items.push({
            beginGroup: true,
            text: "Mark As Settled",
            icon: "check-ledger",
            template: "contextMenuTemplate",
            onClick: function () {
                confirm("Are you sure you wish to mark the rental as settled?", "Warning!").then(resp => {
                    if (resp)
                        markShortTermRentalAsSettled(e.row.key)
                })
            },
        });
    }

    const StatusColumn = (props) => {
        if (props.data["Settled"]) { //COMPLETED
            return (<label key={props.key} className="form-check-label" htmlFor="ps-unoccupied"><span
                className="status-color occupied"></span>{props.data["Status"]}</label>)
        } else { //OVERDUE
            return (<label key={props.key} className="form-check-label" htmlFor="ps-overdue"><span
                className="status-color overdue"></span>{props.data["Status"]}</label>)
        }
    }
    //#endregion

    return (
        <>
            <div
                className="d-flex flex-wrap flex-lg-nowrap justify-content-between align-items-center px-3 pt-3 bg-white border-bottom">
                <div className="d-flex align-items-center fs-5 mb-3">
                  <span className="text-secondary cursor-pointer" onClick={() => navigate(-1)}>
                    Property Listings
                  </span>
                    <Image
                        src="/svg/chevron-left.svg"
                        alt="chevron-left"
                        width="20"
                        height="20"
                        className="mx-1"
                    />
                    <h2 className="fs-5 fw-medium mb-0 flex-shrink-0 me-4">
                        Short Term Rentals
                    </h2>
                </div>
                <div className="d-flex flex-wrap flex-xl-nowrap mb-3">
                    <Button variant="outline-primary" className="px-3" onClick={exportGridData}>
                        Export All Data
                    </Button>
                </div>
            </div>
            <div className="main-wrapper p-3">
                <Card className="p-3 border-0">
                    <div className="row mb-3">
                        <div className="col-sm-12 col-lg-4 mb-3 mb-xl-0">
                            <Card className="card-light p-3 border-0 text-center h-100 justify-content-center">
                                <div className="fs-4 fw-bold mb-1">
                                    {selectedProperty["Name"]}
                                </div>
                                <div className="text-secondary text-uppercase">
                                    Property name
                                </div>
                            </Card>
                        </div>
                        <div className="col-md-12 col-lg-8">
                            <div className="row">
                                <div className="col-6 col-md-4 col-lg-4 col-xl col-md mb-3 mb-xl-0">
                                    <Card className="card-light p-3 border-0 text-center h-100">
                                        <div className="fs-4 fw-bold mb-1">
                                            {selectedProperty && selectedProperty["DisplayStartDate"] > 0
                                                ? selectedProperty["DisplayStartDate"]
                                                : "N/A"}
                                        </div>
                                        <div className="text-secondary text-uppercase">
                                            Start date
                                        </div>
                                    </Card>
                                </div>
                                <div className="col-6 col-md-4 col-lg-4 col-xl mb-3 mb-xl-0">
                                    <Card className="card-light p-3 border-0 text-center h-100">
                                        <div className="fs-4 fw-bold mb-1 text-capitalize">
                                            {selectedProperty && selectedProperty["DisplayStartDate"] > 0
                                                ? selectedProperty["DisplayEndDate"]
                                                : "N/A"}
                                        </div>
                                        <div className="text-secondary text-uppercase">
                                            End date
                                        </div>
                                    </Card>
                                </div>
                                <div className="col-6 col-md-4 col-lg-4 col-xl mb-3 mb-xl-0">
                                    <Card className="card-light p-3 border-0 h-100">
                                        <span className="fs-7 mb-1 align-self-center">
                                          {generatePropertyStatus(selectedProperty)}
                                        </span>
                                        <div className="text-secondary text-uppercase align-self-center">
                                            Property Status
                                        </div>
                                    </Card>
                                </div>
                                <div className="col-6 col-md-4 col-lg-4 col-xl mb-3 mb-xl-0">
                                    <Card className="card-light p-3 border-0 text-center h-100">
                                        <div className="fs-4 fw-bold mb-1 text-capitalize">
                                            {selectedProperty["PropertyType"]}
                                        </div>
                                        <div className="text-secondary text-uppercase">
                                            Property type
                                        </div>
                                    </Card>
                                </div>
                                <div className="col-6 col-md-4 col-lg-4 col-xl mb-3 mb-xl-0">
                                    <Card className="card-light p-3 border-0 h-100">
                                        <span className="fs-7 mb-1 align-self-center">
                                          {generateContractStatus(gridData[0], true)}
                                        </span>
                                        <div className="text-secondary text-uppercase align-self-center">
                                            Contract Expiry
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="rounded p-3 border border-secondary mb-3">
                        <div className="card-body p-0">
                            <div
                                className="d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center mb-2">
                                <div className="d-sm-flex align-items-center justify-content-between">
                                    <Button
                                        variant="outline-primary"
                                        className="flex-shrink-0 me-3"
                                        onClick={backToPreviousPage}
                                    >
                                        <Image src="/svg/chevron-left-green.svg"
                                               alt="refresh" width="20"
                                               height="20"/>
                                        Back to Previous
                                    </Button>
                                </div>
                                <div className="d-flex">
                                    <Button
                                        variant="outline-primary"
                                        className="flex-shrink-0 me-3"
                                        onClick={addNewShortTermRental}
                                    >
                                        Add Rental
                                    </Button>
                                    <Button
                                        variant="outline-primary"
                                        className="flex-shrink-0 me-3"
                                        onClick={clearFilter}
                                    >
                                        Clear Filter
                                    </Button>
                                    <InputGroup className="me-3 search-input">
                                        <TextBox
                                            ref={contractsSearchRef}
                                            placeholder="Search Transactions..."
                                            mode="search"
                                            inputAttr={{class: "form-control temp"}}
                                            elementAttr={{class: "search-input input-group"}}
                                            width="100%"
                                            onValueChanged={searchShortTermRentalByText}
                                        ></TextBox>
                                    </InputGroup>
                                </div>
                            </div>
                            <DataGrid
                                ref={gridInstance}
                                dataSource={gridData}
                                {...gridCustomization}
                                onContextMenuPreparing={contextMenu}
                                keyExpr="externalId"
                                height={500}
                                onCellPrepared={cellPrepared}
                            >
                                {gridColumns.map((column, i) => (
                                    cl.generateReactColumnsFromJson(column)
                                ))}
                                {gridColumns.map((column, i) => (
                                    cl.generateActionButtonColumn(column)
                                ))}
                                <Template name="myTemplate" render={MoreOptionsButton}/>
                                <Template name="contextMenuTemplate" render={ContextMenuTemplate}/>
                                <Template name={"statusTemplate"} render={StatusColumn}/>
                            </DataGrid>
                            <PropertyShortTermRentalDetails
                                show={shortTermRentalSettings.show}
                                externalId={shortTermRentalSettings.externalId}
                                readOnly={shortTermRentalSettings.readOnly}
                                property={shortTermRentalSettings.property}
                                handleClose={() => {
                                    setShortTermRentalSettings({
                                        ...shortTermRentalSettings,
                                        show: false,
                                        externalId: ""
                                    })
                                }}
                                isUpdated={() => {
                                    getData(true)
                                }}
                            ></PropertyShortTermRentalDetails>
                        </div>
                    </div>
                </Card>
            </div>
        </>
    );
};

export default connect(mapStateToProps)(PropertyShortTermRental);
